import MoreTimeIcon from '@mui/icons-material/MoreTime';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import UpdateIcon from '@mui/icons-material/Update';
import SickIcon from '@mui/icons-material/Sick';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import MoneyOffCsredIcon from '@mui/icons-material/MoneyOffCsred';
import BabyChangingStationIcon from '@mui/icons-material/BabyChangingStation';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import MasksIcon from '@mui/icons-material/Masks';
import ElderlyWomanIcon from '@mui/icons-material/ElderlyWoman';
import SchoolIcon from '@mui/icons-material/School';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import StartIcon from '@mui/icons-material/Start';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

export const requestTypesIcons = {
  timeCorrection: <MoreTimeIcon />,
  timeCompensation: <UpdateIcon />,
  vacation: <FlightTakeoffIcon />,
  sick: <SickIcon />,
  travelExpense: <DirectionsCarIcon />,
};

export const requestTypesStrings = {
  timeCorrection: 'Time Correction',
  timeCompensation: 'Time Compensation',
  vacation: 'Vacation',
  sick: 'Sick',
  travelExpense: 'Travel Expense',
};

export const vacationTypes = {
  0: {
    label: 'Vacation',
    value: 0,
    icon: <BeachAccessIcon />,
  },
  1: {
    label: 'Unpaid vacation',
    value: 1,
    icon: <MoneyOffCsredIcon />,
  },
  2: {
    label: 'Maternity leave',
    value: 2,
    icon: <PregnantWomanIcon />,
  },
  3: {
    label: 'Paternity leave',
    value: 3,
    icon: <BabyChangingStationIcon />,
  },
  4: {
    label: 'Parental leave',
    value: 4,
    icon: <FamilyRestroomIcon />,
  },
  5: {
    label: 'Child sick leave',
    value: 5,
    icon: <MasksIcon />,
  },
  6: {
    label: 'Care leave',
    value: 6,
    icon: <ElderlyWomanIcon />,
  },
  7: {
    label: 'Educational leave',
    value: 7,
    icon: <SchoolIcon />,
  },
  8: {
    label: 'Time Compensation',
    value: 8,
    icon: <HistoryToggleOffIcon />,
  },
};
